import React, { ReactElement } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import { FormikProps } from 'formik'

const StateDropdown = <T extends { state: string }>({
  form,
  label = 'State',
  variant = 'standard',
}: {
  form: FormikProps<T>
  label?: string
  variant?: 'filled' | 'outlined' | 'standard'
}): ReactElement => (
  <FormControl fullWidth>
    <InputLabel>{label}</InputLabel>
    <Select
      sx={{ bgcolor: 'background.paperDark' }}
      variant={variant}
      value={form.values.state}
      label={label}
      name="state"
      onChange={form.handleChange}
      error={form.touched.state && !!form.errors.state}
    >
      <MenuItem key="unselected" value="unselected">
        Unselected
      </MenuItem>
      <MenuItem value="Alaska">Alaska</MenuItem>
      <MenuItem value="Alabama">Alabama</MenuItem>
      <MenuItem value="Antigua and Barbuda">Antigua and Barbuda</MenuItem>
      <MenuItem value="Arkansas">Arkansas</MenuItem>
      <MenuItem value="Australia">Australia</MenuItem>
      <MenuItem value="Arizona">Arizona</MenuItem>
      <MenuItem value="The Bahamas">The Bahamas</MenuItem>
      <MenuItem value="Belgium">Belgium</MenuItem>
      <MenuItem value="California">California</MenuItem>
      <MenuItem value="Canada">Canada</MenuItem>
      <MenuItem value="Colorado">Colorado</MenuItem>
      <MenuItem value="Connecticut">Connecticut</MenuItem>
      <MenuItem value="Czech Republic">Czech Republic</MenuItem>
      <MenuItem value="Delaware">Delaware</MenuItem>
      <MenuItem value="DHS">DHS</MenuItem>
      <MenuItem value="District of Columbia">District of Columbia</MenuItem>
      <MenuItem value="Ecuador">Ecuador</MenuItem>
      <MenuItem value="Florida">Florida</MenuItem>
      <MenuItem value="France">France</MenuItem>
      <MenuItem value="Georgia">Georgia</MenuItem>
      <MenuItem value="Germany">Germany</MenuItem>
      <MenuItem value="Great Britain">Great Britain</MenuItem>
      <MenuItem value="Guam">Guam</MenuItem>
      <MenuItem value="Hawaii">Hawaii</MenuItem>
      <MenuItem value="Iowa">Iowa</MenuItem>
      <MenuItem value="Idaho">Idaho</MenuItem>
      <MenuItem value="Illinois">Illinois</MenuItem>
      <MenuItem value="Indiana">Indiana</MenuItem>
      <MenuItem value="Iraq">Iraq</MenuItem>
      <MenuItem value="Ireland">Ireland</MenuItem>
      <MenuItem value="Kansas">Kansas</MenuItem>
      <MenuItem value="Kentucky">Kentucky</MenuItem>
      <MenuItem value="Louisiana">Louisiana</MenuItem>
      <MenuItem value="Liechtenstein">Liechtenstein</MenuItem>
      <MenuItem value="Massachusetts">Massachusetts</MenuItem>
      <MenuItem value="Maryland">Maryland</MenuItem>
      <MenuItem value="Maine">Maine</MenuItem>
      <MenuItem value="Mexico">Mexico</MenuItem>
      <MenuItem value="Michigan">Michigan</MenuItem>
      <MenuItem value="Minnesota">Minnesota</MenuItem>
      <MenuItem value="Missouri">Missouri</MenuItem>
      <MenuItem value="Mississippi">Mississippi</MenuItem>
      <MenuItem value="Montana">Montana</MenuItem>
      <MenuItem value="North Carolina">North Carolina</MenuItem>
      <MenuItem value="North Dakota">North Dakota</MenuItem>
      <MenuItem value="Nebraska">Nebraska</MenuItem>
      <MenuItem value="Netherlands">Netherlands</MenuItem>
      <MenuItem value="New Zealand">New Zealand</MenuItem>
      <MenuItem value="New Hampshire">New Hampshire</MenuItem>
      <MenuItem value="New Jersey">New Jersey</MenuItem>
      <MenuItem value="New Mexico">New Mexico</MenuItem>
      <MenuItem value="Nevada">Nevada</MenuItem>
      <MenuItem value="New York">New York</MenuItem>
      <MenuItem value="Ohio">Ohio</MenuItem>
      <MenuItem value="Oklahoma">Oklahoma</MenuItem>
      <MenuItem value="Oregon">Oregon</MenuItem>
      <MenuItem value="Pennsylvania">Pennsylvania</MenuItem>
      <MenuItem value="Puerto Rico">Puerto Rico</MenuItem>
      <MenuItem value="Poland">Poland</MenuItem>
      <MenuItem value="Qatar">Qatar</MenuItem>
      <MenuItem value="Rhode Island">Rhode Island</MenuItem>
      <MenuItem value="Saudi Arabia">Saudi Arabia</MenuItem>
      <MenuItem value="Serbia">Serbia</MenuItem>
      <MenuItem value="South Africa">South Africa</MenuItem>
      <MenuItem value="South Carolina">South Carolina</MenuItem>
      <MenuItem value="Scotland">Scotland</MenuItem>
      <MenuItem value="South Dakota">South Dakota</MenuItem>
      <MenuItem value="Slovakia">Slovakia</MenuItem>
      <MenuItem value="Switzerland">Switzerland</MenuItem>
      <MenuItem value="Tennessee">Tennessee</MenuItem>
      <MenuItem value="Texas">Texas</MenuItem>
      <MenuItem value="Trinidad and Tobago">Trinidad and Tobago</MenuItem>
      <MenuItem value="UAE">UAE</MenuItem>
      <MenuItem value="Utah">Utah</MenuItem>
      <MenuItem value="Virgin Islands">Virgin Islands</MenuItem>
      <MenuItem value="Virginia">Virginia</MenuItem>
      <MenuItem value="Vermont">Vermont</MenuItem>
      <MenuItem value="Washington">Washington</MenuItem>
      <MenuItem value="Wisconsin">Wisconsin</MenuItem>
      <MenuItem value="West Virginia">West Virginia</MenuItem>
      <MenuItem value="Wyoming">Wyoming</MenuItem>
    </Select>
  </FormControl>
)

export default StateDropdown
